var _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyLeads = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 153,
  height: 153,
  fill: "none"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "emptyLeads_svg__a",
  width: 153,
  height: 153,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 76.5,
  cy: 76.5,
  r: 76.5,
  fill: "#F3F6F9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#emptyLeads_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 76.5,
  cy: 76.5,
  r: 76.5,
  fill: "#E9ECEF"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#emptyLeads_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F8F8FD",
  d: "M41 33h165v129H41z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#emptyLeads_svg__c)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 149,
  height: 15,
  x: 54,
  y: 47,
  fill: "#fff",
  rx: 2
})), /*#__PURE__*/React.createElement("circle", {
  cx: 66.5,
  cy: 54.5,
  r: 3.5,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  width: 74,
  height: 2,
  x: 73,
  y: 54,
  fill: "#E4E8F1",
  rx: 1
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#emptyLeads_svg__d)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 149,
  height: 62,
  x: 54,
  y: 74,
  fill: "#fff",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 63,
  y: 81,
  fill: "#E4E8F1",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 2,
  fill: "#E4E8F1",
  rx: 1,
  transform: "matrix(-1 0 0 1 113 81)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 127,
  y: 81,
  fill: "#E4E8F1",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 2,
  fill: "#E4E8F1",
  rx: 1,
  transform: "matrix(-1 0 0 1 171 81)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 63,
  y: 97,
  fill: "#E4E8F1",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 2,
  fill: "#E4E8F1",
  rx: 1,
  transform: "matrix(-1 0 0 1 105 97)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 127,
  y: 97,
  fill: "#E4E8F1",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 2,
  fill: "#E4E8F1",
  rx: 1,
  transform: "matrix(-1 0 0 1 177 97)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 63,
  y: 112,
  fill: "#E4E8F1",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 2,
  fill: "#E4E8F1",
  rx: 1,
  transform: "matrix(-1 0 0 1 107 112)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 127,
  y: 112,
  fill: "#E4E8F1",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 2,
  fill: "#E4E8F1",
  rx: 1,
  transform: "matrix(-1 0 0 1 164 112)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 63,
  y: 128,
  fill: "#E4E8F1",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 2,
  fill: "#E4E8F1",
  rx: 1,
  transform: "matrix(-1 0 0 1 111 128)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 127,
  y: 128,
  fill: "#E4E8F1",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 2,
  fill: "#E4E8F1",
  rx: 1,
  transform: "matrix(-1 0 0 1 177 128)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E4E8F1",
  d: "M54 89.5h149M54 105.5h149M54 121.5h149",
  opacity: 0.5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "emptyLeads_svg__b",
  width: 173,
  height: 137,
  x: 37,
  y: 33,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.130469 0 0 0 0 0.254849 0 0 0 0 0.695833 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "emptyLeads_svg__c",
  width: 153,
  height: 19,
  x: 52,
  y: 46,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "emptyLeads_svg__d",
  width: 153,
  height: 66,
  x: 52,
  y: 73,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));
export { SvgEmptyLeads as ReactComponent };
export default __webpack_public_path__ + "static/media/emptyLeads.f56f66cc.svg";